/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { useAppSelector } from "../../../../infra/hooks";
import DTOExpiredInsurance from "./DTOExpiredInsurance";
import ExpiredInsurancePresenter from "./ExpiredInsurancePresenter";
import { useTranslation } from "react-i18next";

function ExpiredInsuranceController() {
  const [expiredInsurances, setExpiredInsurances] = useState([]);
  const { t } = useTranslation();

  const isLoading = useAppSelector(
    (state) => state.expiredInsuranceSlice.expiredInsuranceLoader
  );

  function callBackFunc(data: any) {
    setExpiredInsurances(data);
  }

  return (
    <>
      <DTOExpiredInsurance setExpiredInsurancesData={callBackFunc} />
      <ExpiredInsurancePresenter
        insurancesData={expiredInsurances}
        isLoading={isLoading}
        trans={t}
      />
    </>
  );
}

export default ExpiredInsuranceController;
